exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block:nth-child(odd) {\n    background-color: #f8f8f8 !important;\n}\n.invalid {\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 80%;\n    color: #e3352f7c;\n}\n.invalid-border {\n    border-color: #e3342f;\n    padding-right: calc(1.6em + 0.75rem);\n}\n.multiselect__option--highlight {\n    background-color: #497cff;\n}\n.option__desc, .option__image {\n    display: inline-block;\n    vertical-align: middle;\n}\n.option__image {\n    max-height: 80px;\n    margin-right: 10px;\n}\n\n\n\n\n", ""]);

// exports
